import { FDealType, dealTypeFromJsonQuery } from '../../../JsonQuery';
import { useContext } from './useContext';

export function useDealType(): FDealType {
  const { jsonQuery } = useContext();

  return dealTypeFromJsonQuery(jsonQuery);
}
